
import { useState } from 'react';

export type ProfileModelType = 'standard' | 'alternative';

export const useProfileModel = (initialModel: ProfileModelType = 'standard') => {
  const [activeModel, setActiveModel] = useState<ProfileModelType>(initialModel);

  const toggleModel = () => {
    setActiveModel(prev => prev === 'standard' ? 'alternative' : 'standard');
  };

  const getModelLabel = (model: ProfileModelType) => {
    return model === 'standard' ? 'Standard Profile' : 'Alternative Profile';
  };

  const getModelDescription = (model: ProfileModelType) => {
    return model === 'standard' 
      ? 'Current personality profiling method'
      : 'Alternative calculation method';
  };

  return {
    activeModel,
    setActiveModel,
    toggleModel,
    getModelLabel,
    getModelDescription
  };
};
